import { CallIntelStore } from '@frontend/api-call-intel';

export const useCallIntelDemoFlags = () => {
  const { isDemoAccount, isDemoModal } = CallIntelStore.useCallIntelDemoShallowStore('isDemoAccount', 'isDemoModal');
  return {
    isDemoAccount,
    isDemoModal,
    showDemoChipAndBanner: isDemoAccount && !isDemoModal,
  };
};
